<template>
    <el-dialog :visible="visible" width="30%" @close="handleClose" class="dialog" :title="title">
        <div style="display: flex;justify-content: center;" id="printTest">
            <div class="text">
                <div class="hospital"><span>{{ form.hospital || '大庆油田总医院' }}</span></div>
                <div><span>日期：</span>{{ form.date }} {{ form.time }}</div>
                <div><span>姓名：</span>{{ form.name }}</div>
                <div><span>身份证：</span>{{ form.idnum }}</div>
                <div><span>单位：</span>油田公司{{ form.EJDW }}{{ form.SJDW }}</div>
                <div class="project" v-if="form.package">
                    <el-row>
                        <el-col :span="24"><span>项目</span></el-col>
                    </el-row>
                    <div>{{ form.package }}</div>
                </div>
                <div><span>总金额：</span>￥{{ form.fee }}</div>
                <div style="text-align: center; padding-top: 50px;">1</div>
            </div>
        </div>
        <div style="text-align: right">
            <el-button type="primary" size="small" v-print="'#printTest'">打印小票</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            default: false
        },
        title: {
            default: '打印小票'
        },
        form: {
            default: {}
        }
    },
    data() {
        return {}
    },
    methods: {
        handleClose() {
            this.$emit('close')
        }
    }
}
</script>
<style lang="scss" scoped>
.text {
    width: 236px;
    font-size: 15px;
    font-weight: 500;

    span {
        letter-spacing: 2px
    }

    div {
        padding: 1px 0;
    }

    .project {
        text-align: left;
        border-bottom: 1px dashed #909399;
        border-top: 1px dashed #909399;
        margin: 10px 0;
    }
}

.hospital {
    font-size: 25px;
    font-weight: bold;
    text-align: center;
}
</style>
